module.exports = __webpack_public_path__ + "static/media/profile_menu_gray.6a310609.svg";